/**
 * @generated SignedSource<<393fd6d0943bb9859227c577862c9a3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
import { FragmentRefs } from "relay-runtime";
export type PackageDetailBilling_memberPackage$data = {
  readonly cancelledOn: string | null | undefined;
  readonly id: string;
  readonly package: {
    readonly __typename: string;
  };
  readonly squareCard: {
    readonly cardBrand: CardBrand;
    readonly expMonth: number;
    readonly expYear: number;
    readonly lastFour: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CanceledPackageBanner_memberPackage" | "useGetBillingPeriod_memberPackage" | "useGetNextPaymentDate_memberPackage" | "useGetOutstandingOrders_memberPackage" | "useGetPriceMap_memberPackage">;
  readonly " $fragmentType": "PackageDetailBilling_memberPackage";
};
export type PackageDetailBilling_memberPackage$key = {
  readonly " $data"?: PackageDetailBilling_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDetailBilling_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDetailBilling_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetOutstandingOrders_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPriceMap_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBillingPeriod_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetNextPaymentDate_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CanceledPackageBanner_memberPackage"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardBrand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFour",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "c2d57effe7a3017246e48db4d0e0b316";

export default node;
